<script lang="ts" setup>
import { NSwitch } from "naive-ui";


defineProps<{
    modelValue: boolean;
    disabled?: boolean;
    loading?: boolean;
    checkedText?: string;
    uncheckedText?: string;
}>();

const emits = defineEmits<{
    (_e: "update:modelValue", _value: boolean): void;
}>();

function handleUpdateValue(value: boolean) {
    emits("update:modelValue", value);
}
</script>

<template>
    <n-switch
        :value="modelValue"
        :disabled="disabled || loading"
        :loading="loading"
        @update:value="handleUpdateValue"
    >
        <template #checked v-if="checkedText || uncheckedText">
            {{ checkedText ?? "Enabled" }}
        </template>
        <template #unchecked v-if="checkedText || uncheckedText">
            {{ uncheckedText ?? "Disabled" }}
        </template>
    </n-switch>
</template>
